var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarIcon = function SvgCalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 33,
    viewBox: "0 0 31 33"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#DBDBDB"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 32,
    x: 0.5,
    y: 0.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.5h30M0 14.5h30M0 20.5h30M0 26.5h30M6.5 8v24M24.5 8v24M18.5 8v24M12.5 8v24"
  }))));
};
export default SvgCalendarIcon;